<template>
  <div class="flex justify-center">
    <div class="flex" v-for="(item, index) in steps" :key="index">
      <div
        v-if="index > 0"
        class="w-46px h-3px line"
        :class="{ active: index <= active }"
      ></div>
      <div
        class="flex flex-col items-center"
        :style="{ marginLeft: svgSpacing, marginRight: svgSpacing }"
      >
        <svg-icon
          :iconClass="item.iconClass"
          :style="{
            color: index <= active ? 'var(--primary-color)' : '#E1DCE9'
          }"
          class="cursor-pointer"
          @click="stepClick(index)"
        ></svg-icon>
        <p class="mt-17px" :class="{ 'text-pri font-bold': index <= active }">
          {{ item.name }}
        </p>
      </div>
      <div
        v-if="index < steps.length - 1"
        class="w-46px h-3px line"
        :class="{ active: index <= active }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  model: {
    prop: 'active',
    event: 'setActive'
  },
  props: {
    steps: {},
    active: {
      default: 0
    },
    svgSpacing: {
      default: '0.052rem'
    }
  },
  watch: {
    active(val) {
      this.setActive(val)
    }
  },
  created() {},
  mounted() {},
  methods: {
    stepClick(step) {
      if (step < this.active) {
        this.setActive(step)
      }
    },
    setActive(val) {
      this.$emit('setActive', val)
    }
  }
}
</script>
<style lang="scss" scoped>

.line {
  background: #e1dce9;
  margin-top: 21.5px;
  &.active {
    background: var(--primary-color);
  }
}

</style>
